import styled from "styled-components";
import theme from "~/styles/theme";

export const Box = styled.div`
    background: #ffffff;
    border-radius: 1rem;
    padding: 1.375rem 1rem;
    margin-bottom: 0.9375rem;

    p {
        font-size: 20px;
        line-height: 24px;
        color: black;
        margin-bottom: 25px;

        span {
            display: block;
            color: #5b5b5b;
            font-size: 12px;
            line-height: 14px;
        }
    }

    .multiple-choise {
        display: flex;
        flex-wrap: wrap;
        justify-content: space-between;

        div {
            cursor: pointer;
            text-align: center;
            flex: 1 1 110px;
            padding: 10px;
            border: 0.5px solid #989898;
            border-radius: 30px;
            margin-right: 10px;
            margin-bottom: 10px;
            font-size: 12px;
            color: #989898;
            max-width: 140px;

            &.selected,
            &:hover {
                color: #5064ee;
                border: 0.5px solid #5064ee;
            }
        }
    }

    .range-value {
        text-align: center;
        color: #5064ee;
        font-size: 14px;
    }

    button.selector-button {
        background-color: transparent !important;
        padding-bottom: 15px;
    }

    .label-selector {
        padding-top: 7px !important;
        font-size: 10px;
    }

    .period-book button {
        all: unset;
        width: 100%;
    }

    .period-selector {
        padding: 12px 26px;
        font-family: Inter;
        font-style: normal;
        font-weight: 600;
        font-size: 10px;
        line-height: 12px;
        color: #989898;
        border: 0.5px solid #989898;
        box-sizing: border-box;
        border-radius: 30px;

        &.selected,
        &[tabindex]:focus,
        &:hover {
            color: #5064ee;
            border: 0.5px solid #5064ee;
        }
    }

    @media (min-width: 920px) {
        .label-selector {
            padding-top: 5px !important;
            font-size: 12px;
        }
        button.selector-button {
            padding-bottom: 17px;
        }
    }
`;

export const Header = styled.header`
    padding: 1rem 0;
    text-align: left;

    h1 {
        color: ${theme.color.primary.background};
    }

    span {
        color: ${theme.color.baseLighter};
        font-size: 1rem;
    }
`;

export const Content = styled.div<{ size?: number }>`
    width: ${({ size }) => (size ? size + "%" : "100%")};
    background: #ffffff;

    padding: 1rem;
    margin: 0.8rem auto;
    box-shadow: 0px 0px 4px rgba(0, 0, 0, 0.25);
    border-radius: 1rem;

    .button-container {
        button {
            margin: 1rem 0;
        }
    }

    .input-content {
        span {
            color: ${theme.color.terciary.accent};
        }
        label {
            border: none;
        }
    }
    .check-content {
        display: flex;
        flex-direction: column;
        padding: 0.3rem 0;

        label {
            font-size: 1rem;
            line-height: 1.5rem;
            color: ${theme.color.terciary.accent};
        }
    }

    .row {
        margin: 0.5rem 0;
    }

    .col-lg-3 {
        margin: 0.5rem 0;
    }

    .selected {
        color: ${(props) => props.theme.color.primary.foreground};
        background-color: ${(props) => props.theme.color.primary.background};
        border-color: ${(props) => props.theme.color.primary.background};

        &:hover {
            color: #fff;
        }
    }

    .header-content {
        .bar {
            display: flex;
            justify-content: space-between;
            align-items: center;
            border-bottom: 1px solid ${theme.color.baseLighter};

            button {
                background: none;
                cursor: pointer;

                display: flex;
                align-items: center;
            }
        }
    }

    .title {
        p {
            font-size: 1.5rem;
            padding-bottom: 1rem;
        }

        label {
            font-size: 1rem;
            line-height: 1.5rem;
        }

        .bar {
            display: flex;
            justify-content: space-between;
            align-items: center;
            border-bottom: 1px solid ${theme.color.baseLighter};
        }
    }

    div {
        margin: 0.1rem 0;
        strong {
            padding: 0.2rem 1rem 0.5rem 0.5rem;
            font-size: 1.5rem;
        }

        textarea {
            margin-top: 0.5rem;
            border: none;
            font-size: 1rem;
            line-height: 1.5rem;
            font-family: "Inter", sans-serif;

            &:focus {
                outline: 0;
                box-shadow: 0 0 0 0;
            }
        }

        @media (max-width: 540px) {
            strong {
                font-size: 1.2rem;
            }
        }
    }

    span {
        color: ${theme.color.baseLighter};
        font-size: 0.875rem;
    }

    button {
        color: ${theme.color.baseLighter};
        border-color: ${theme.color.baseLighter};
    }

    p {
        color: ${theme.color.base};
        font-weight: 600;
    }

    textarea {
        margin-top: 0.5rem;
        border: none;
        font-size: 1rem;
        line-height: 1.5rem;
        font-family: "Inter", sans-serif;

        &:focus {
            outline: 0;
            box-shadow: 0 0 0 0;
        }
    }

    @media (max-width: 980px) {
        width: 80%;
    }

    @media (max-width: 740px) {
        width: 100%;
    }

    @media (max-width: 480px) {
        .row {
            gap: 1rem;
        }

        .col-lg-3 {
            margin: 0.1rem 0;
        }
    }
`;

export const Footer = styled.footer<{ size?: number }>`
    width: ${({ size }) => (size ? size + "%" : "100%")};
    min-height: 5rem;
    display: flex;
    align-items: center;
    justify-content: center;
    margin: 0 auto;

    button {
        margin: 0 0.3rem;
    }

    @media (max-width: 980px) {
        width: 80%;
    }

    @media (max-width: 740px) {
        width: 100%;

        button {
            font-size: 0.85rem;
        }
    }

    @media (max-width: 370px) {
        button {
            font-size: 0.8rem;
        }
    }
`;

export const SuccessContainer = styled.div`
    max-width: 33.75rem;
    height: 11.5rem;
    width: 100%;

    margin: 0 auto;
    border: 4px solid #0dd735;
    box-shadow: 0px 0px 4px rgba(0, 0, 0, 0.25);
    border-radius: 15px;

    display: flex;
    flex-direction: column;
    justify-content: space-evenly;
    align-items: center;

    p {
        font-size: 1.5rem;
        font-weight: 600;
        color: #0dd735;
    }
`;

export const SuccessMessage = styled.div`
    display: flex;
    justify-content: center;
    max-width: 33.75rem;
    margin: 0 auto;
    text-align: center;

    h2 {
        color: ${theme.color.primary.background};
    }
`;

export const TimeLineContent = styled.div`
    max-width: 36rem;
    margin: 0 auto;

    .vertical-timeline {
        &:before {
            top: 2rem;
            height: 75%;
        }
    }
`;

export const WraperGrid = styled.div`
    display: grid;
    grid-template-columns: 3fr 1fr;
    gap: 1rem;

    @media (max-width: 980px) {
        grid-template-columns: 1fr;
    }
`;

export const ModalContent = styled.div<{ owner: boolean }>`
    display: grid;
    grid-template-columns: 1fr 2fr;
    gap: 1rem;

    .img {
        position: relative;
        width: 100%;
    }

    .content {
        overflow: hidden;
        h1 {
            color: ${theme.color.primary.background};
            margin-bottom: 1rem;
        }

        p {
            margin: 1rem 0;
            font-size: 1rem;
            line-height: 1.5rem;
        }

        span {
            font-weight: bold;
            color: ${theme.color.primary.background};
        }

        a {
            color: ${theme.color.primary.background};
            line-height: 1rem;
        }
    }

    .links {
        margin: 1rem 0;
    }

    .buttons {
        margin: 1rem 0;
        display: flex;

        button {
            &:last-child {
                margin-left: ${({ owner }) => (owner ? "1rem" : "")};
            }
        }
    }

    @media (max-width: 800px) {
        grid-template-columns: 1fr;

        .buttons {
            display: flex;
            align-items: center;
            justify-content: center;
            button {
                width: 9rem;
            }
        }
    }
`;

export const WhatsappButton = styled.button<{ step }>`
    position: fixed;
    z-index: 2;
    right: 2rem;
    bottom: ${({ step }) => (step === 2 ? "32rem" : "15rem")};
    background: none !important;
    cursor: pointer;
    overflow: hidden;
    transition: ease-in-out 0.2s;

    img {
        overflow: hidden;
    }

    &:hover {
        transform: scale(1.2);
        overflow: hidden;
    }

    @media (max-width: 1440px) {
        bottom: ${({ step }) => (step === 2 ? "10rem" : "2rem")};
    }

    @media (max-width: 450px) {
        bottom: 2rem;
    }
`;
